import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {useCodeRepositories} from '../hooks/useCodeRepositories';
import {CodeRepository} from '../types';
import {FieldProps} from 'formik';

export const CodeRepositoriesAutocomplete = ({
                                                 field: {
                                                     name,
                                                     value: fieldValue,
                                                 },
                                                 form: {setFieldValue},
                                                 ...rest
                                             }: FieldProps) => {

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const {items: records} = useCodeRepositories();

    const data = records.map((record: CodeRepository) => {
        return {
            ...record,
            label: record.name || '',
            value: record.name || '',
        };
    });

    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        if (fieldValue) {
            setValue(fieldValue);
        }
    }, [records.length, fieldValue]);

    const handleChange = (value: string) => {
        setFieldValue(name, value);
        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Code Repository'
            {...rest}
        />
    );
};
